var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Receivable),
      expression: "Receivable"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("履约分析表")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px"
    }
  }, [_c('span', [_vm._v("组织架构")]), _vm._v(" "), _c('el-cascader', {
    staticStyle: {
      "margin-left": "10px",
      "width": "300px"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    on: {
      "change": _vm.changeCascader
    },
    model: {
      value: (_vm.project_id),
      callback: function($$v) {
        _vm.project_id = $$v
      },
      expression: "project_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("区域总监 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "margin-top": "-10px"
    },
    attrs: {
      "placeholder": _vm.postPlaceholder,
      "clearable": ""
    },
    model: {
      value: (_vm.condition.area_manager_id),
      callback: function($$v) {
        _vm.$set(_vm.condition, "area_manager_id", $$v)
      },
      expression: "condition.area_manager_id"
    }
  }, _vm._l((_vm.overmanList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.staff_name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "20px 20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "goon"
    },
    on: {
      "click": _vm.Find
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "190px"
    }
  }, [_c('download-excel', {
    staticClass: "export-excel-wrapper",
    staticStyle: {
      "margin-left": "-180px",
      "top": "100px"
    },
    attrs: {
      "fields": _vm.download_excel,
      "title": "调岗人员清单",
      "name": "调岗人员清单.xls",
      "fetch": _vm.ExportForm
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "85px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "goon"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t导出")])], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "1% 3% 0 3%"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "header-cell-style": {
        background: '#d3eae2',
        color: '#000000'
      },
      "span-method": _vm.objectSpanMethod,
      "border": "",
      "summary-method": _vm.getSummaries,
      "height": "600",
      "cell-class-name": _vm.tableRowClassName
    },
    on: {
      "selection-change": _vm.handleSelectionChange,
      "cell-mouse-leave": _vm.cellMouseLeave,
      "cell-mouse-enter": _vm.cellMouseEnter
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "序号",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope_1) {
        return [_vm._v(_vm._s(scope_1.$index + 1))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "organizeName",
      "label": "架构",
      "width": "300"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "areaManagerName",
      "align": "center",
      "label": "区域总监"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "",
      "align": "center",
      "label": "项目数量",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.projectQuantity))]), _vm._v(" "), _c('el-popover', {
          attrs: {
            "placement": "right",
            "title": "项目详情",
            "width": "300",
            "trigger": "click"
          }
        }, [_c('el-table', {
          attrs: {
            "show-header": false,
            "data": _vm.gridData
          }
        }, [_c('el-table-column', {
          attrs: {
            "align": "center",
            "label": "",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope_1) {
              return [_vm._v(_vm._s(scope_1.$index + 1))]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "200",
            "property": "partnerName"
          }
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "50",
            "property": "uncollected_payment_money"
          }
        })], 1), _vm._v(" "), _c('img', {
          staticStyle: {
            "width": "16px",
            "height": "16px",
            "vertical-align": "middle",
            "margin-top": "-3px"
          },
          attrs: {
            "slot": "reference",
            "src": require("../../../assets/icon/双箭头下.png")
          },
          on: {
            "click": function($event) {
              return _vm.areaManager(scope.row)
            }
          },
          slot: "reference"
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "uncollected_payment_money",
      "align": "center",
      "label": "欠款金额"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "localProportions",
      "align": "center",
      "label": "各总监应收占比"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "localProportion",
      "align": "center",
      "label": "整体占比"
    }
  })], 1)], 1)])])])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bef76e52","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tender/Agreement/Agreement.vue
// module id = null
// module chunks = 